exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gce-auto-healing-policy-modal .form-group {\n  width: 100%;\n  margin-top: 10px;\n}\n.gce-auto-healing-policy-modal .input-group {\n  width: 100%;\n}\n.gce-auto-healing-policy-modal .input-group .input-group-addon {\n  width: 20%;\n}\n", ""]);

